{
  "id": "tutorials",
  "title": "Tutorials",
  "blurb": "",
  "description": "Explore how to use Automatarium with the following tutorials.",
  "type": "section",
  "items": [
    {
      "id": "creating-project-walkthrough",
      "title": "Getting Started",
      "blurb": "In this tutorial, learn how to create a project and customise your workspace in Automatarium.",
      "description": "<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>",
      "type": "item",
      "link": "https://youtu.be/BpCn5adYPEs"
    },
    {
      "id": "transitions-walkthrough",
      "title": "Transitions Tutorial",
      "blurb": "In this tutorial, learn how to manage transitions using Automatarium's unique features.",
      "description": "<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>",
      "type": "item",
      "link": "https://youtu.be/ciRVwFgT1eg"
    },
    {
      "id": "fsa-walkthrough",
      "title": "FSA Tutorial",
      "blurb": "In this tutorial, learn how to create a Finite State Automaton in Automatarium.",
      "description": "<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>",
      "type": "item",
      "link": "https://youtu.be/kiG8RlEaaHw"
    },
    {
      "id": "pda-walkthrough",
      "title": "PDA Tutorial",
      "blurb": "In this tutorial, learn how to create a Pushdown Automaton in Automatarium.",
      "description": "<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>",
      "type": "item",
      "link": "https://youtu.be/ZPbuYOLs2QA"
    },
    {
      "id": "tm-walkthrough",
      "title": "TM Tutorial",
      "blurb": "In this tutorial, learn how to create a Turing Machine in Automatarium.",
      "description": "<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>",
      "type": "item",
      "link": "https://youtu.be/Hg2APtqHlTk"
    },
    {
      "id": "template-walkthrough",
      "title": "Templates Tutorial",
      "blurb": "In this tutorial, learn how to use templates in Automatarium.",
      "description": "<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>",
      "type": "item",
      "link": "https://youtu.be/lCQb5q-DVU0"
    },
    {
      "id": "module-walkthrough",
      "title": "Modules Tutorial",
      "blurb": "In this tutorial, learn how to use modules in Automatarium.",
      "description": "<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>",
      "type": "item",
      "link": "https://youtu.be/mjEWi34XD3c"
    }
  ]
}